export const USER_ENDPOINTS = {
    GET_USER: 'get-create-user',
    UPDATE_USER: 'users',
    GET_OR_CREATE_USER: 'users',
}

export const FANTASY_ENDPOINTS = {
    GET_CONFIG: 'configuration'
}

export const GAMIFICATION_ENDPOINTS = {
    GET_CONFIG: 'configuration',
    GET_ACHIEVEMENTS: 'achievements',
    ENGAGEMENT: `user-engagement`,
    CLAIM_CODE: `claimCode`,
    DAILY_EXP_CLAIM: `claimExp`,
    FASTEST_SHOT_LEADERBOARD: 'fastest-shot/leaderboards'
}

export const API_ENDPOINTS = {
    SEASON_EVENTS: 'events',
    GET_FEED: 'home-feed',
    GET_FEED_BY_ID: 'feed-by-id',
    GET_FEED_BY_TAG: 'feeds',
    GET_GAME_HIGHLIGHTS: 'game-highlights',
    ACADEMY_EVENTS: 'academy/events',
    ACADEMY_VERIFIED_CLUBS: 'academy/verified-clubs',
    DRAFT_BOARD_PLAYERS: 'draft/predictions',
    QUESTIONS: 'questions',
}

export const  WLL_ENDPOINTS = {
    SEASON_EVENTS: 'wll/events'
}